import { SxProps } from '@mui/system';

export const CancelButtonStyle: SxProps = {
  position: { md: 'absolute', lg: 'absolute', xl: 'absolute', xs: 'absolute' },
  left: { md: '0.5em', lg: '0.5em', xl: '0.5em', xs: '0.5em' },
};
